import React, { useState } from 'react'

import ReportsDemoTable, { ReportsDemoCells, ReportsDemoRow, ReportsDemoSelectionBar } from 'Pages/ReportsAlerts/Reports/@components/DemoTable'


const DEMO_REPORTS = [
	{
		name: 'Spain - Madrid Airport Rating',
		searches: 320,
		sites: ['rentalspot.demo', 'pricefly.demo'],
		hours: ['08:00', '14:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays'],
		pickup: 'Madrid Airport (MAD)',
		date: '10 Feb 2025 08:15',
		status: 'ready',
		enabled: true,
		hasRating: true,
	},
	{
		name: 'UK - Heathrow Rating Monitor',
		searches: 1080,
		sites: ['bookride.demo', 'findwheels.demo', 'autolink.demo'],
		hours: ['06:00', '12:00', '18:00'],
		frequency: ['Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays'],
		pickup: 'Heathrow Airport (LHR)',
		date: null,
		status: 'running',
		progress: 54,
		completeTasks: '583',
		totalTasks: '1080',
		enabled: true,
		hasRating: false,
	},
	{
		name: 'France - Paris CDG Rating',
		searches: 192,
		sites: ['rentalspot.demo'],
		hours: ['10:00'],
		frequency: ['Tuesdays', 'Thursdays'],
		pickup: 'Paris CDG Airport (CDG)',
		date: '08 Feb 2025 10:22',
		status: 'ready',
		enabled: true,
		hasRating: false,
	},
	{
		name: 'Italy - Rome FCO Rating',
		searches: 96,
		sites: ['pricefly.demo', 'bookride.demo'],
		hours: ['09:00'],
		frequency: ['Mondays'],
		pickup: 'Rome Fiumicino (FCO)',
		date: '03 Feb 2025 09:10',
		status: 'stopped',
		enabled: false,
		hasRating: false,
	},
	{
		name: 'Germany - Munich MUC Rating',
		searches: 480,
		sites: ['rentalspot.demo', 'pricefly.demo', 'findwheels.demo'],
		hours: ['07:00', '13:00', '19:00'],
		frequency: ['Mondays', 'Wednesdays', 'Fridays', 'Sundays'],
		pickup: 'Munich Airport (MUC)',
		date: '10 Feb 2025 19:03',
		status: 'ready',
		enabled: true,
		hasRating: true,
	},
]

// The quick links each finished report shows under its date
const linksOf = r => r.hasRating ? ['rating', 'realtime', 'multireport'] : []

export default function RatingReportsDemoData() {
	// ticked rows, as the real table keeps them: the selection bar shows while one is ticked
	const [selected, setSelected] = useState([])
	const toggle = name => setSelected(list => list.includes(name) ? list.filter(n => n !== name) : [...list, name])

	return <ReportsDemoTable
		title="Reports List"
		count={DEMO_REPORTS.length}
		selection={!!selected.length && <ReportsDemoSelectionBar reports={DEMO_REPORTS.filter(r => selected.includes(r.name))} onClear={() => setSelected([])}/>}
	>
		{DEMO_REPORTS.map(r => <ReportsDemoRow key={r.name} selected={selected.includes(r.name)} onToggle={() => toggle(r.name)}>
			<ReportsDemoCells report={r} links={linksOf(r)} withForce/>
		</ReportsDemoRow>)}
	</ReportsDemoTable>
}
